<template>
  <div class="h-40 flex items-center justify-center w-full">
    <slot />
  </div>
</template>
